import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const links = [
    { name: 'Accueil', path: '/' },
    { name: 'Location Kayak', path: '/location-de-kayak/' },
    { name: 'Matériels & Équipements', path: '/materiels-equipements/' },
    { name: "Guide de Taha'a", path: "/guide-tahaa/" },
    { name: 'Contact', path: '/formulaire-de-contact/' },
    { name: 'Admin', path: '/admin' },
  ];

  return (
    <nav className="fixed w-full z-50 bg-white/95 backdrop-blur-md border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          
          {/* LOGO SECTION */}
          <Link to="/" className="flex-shrink-0 flex items-center gap-3 group">
            <img 
              src="/images/logo-tahaa.png" 
              width="160"
              height="64"
              className="h-16 w-auto object-contain transition-transform group-hover:scale-105" 
              alt="Logo Tahaa Lagoon Kayak" 
            />
            <span className="font-bold text-lg lg:text-xl tracking-tight text-slate-900 hidden sm:block">
              Tahaa Lagoon Kayak
            </span>
          </Link>
          
          {/* DESKTOP MENU */}
          <div className="hidden md:flex items-center space-x-6">
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-semibold transition-colors hover:text-cyan-600 ${
                  location.pathname === link.path ? 'text-cyan-600' : 'text-slate-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a 
              href="https://tahaa-excursions.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-sm font-bold text-amber-600 hover:text-amber-700 flex items-center gap-1 bg-amber-50 px-3 py-2 rounded-xl transition-all"
            >
              Tours Bateau <ChevronRight size={14} />
            </a>
          </div>

          {/* MOBILE TOGGLE */}
          <div className="md:hidden">
            <button 
              onClick={() => setIsOpen(!isOpen)} 
              aria-label="Menu"
              className="p-2 rounded-lg text-slate-700 hover:bg-slate-50 transition-colors"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* MOBILE MENU */}
      {isOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 absolute w-full shadow-xl animate-in slide-in-from-top-5">
          <div className="px-4 pt-2 pb-6 space-y-2">
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-xl text-base font-bold transition-colors ${
                  location.pathname === link.path 
                    ? 'bg-cyan-50 text-cyan-600' 
                    : 'text-slate-700 hover:bg-slate-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <hr className="my-2 border-slate-100" />
            <a 
              href="https://tahaa-excursions.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="block px-4 py-4 text-base font-black text-amber-600 bg-amber-50 rounded-xl text-center"
            >
              Voir les Tours Guidés Bateau
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;